module.exports = __webpack_public_path__ + "img/164w.e6871d6.jpg";